import { render, staticRenderFns } from "./OrderAction.vue?vue&type=template&id=77b50b4a&"
import script from "./OrderAction.vue?vue&type=script&lang=js&"
export * from "./OrderAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports